import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MergeComponent } from './components/merge/merge.component';

const routes: Routes = [
  {
    path: 'form/:sampletype/:id',
    component: MergeComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MergeRoutingModule { }
